import React from 'react';
import StaticPage from './StaticPage.jsx';

const ShippingPage = () => (
    <StaticPage
        title="Shipping & Returns — Map Shaper"
        description="How products ordered through Map Shaper are printed, shipped, and returned."
        heading="Shipping & Returns"
        intro="Products are printed and shipped by our partner Zazzle. Here's what that means in practice."
    >
        <h2>How fulfilment works</h2>
        <p>
            When you click Order on a product, you're sent to Zazzle's checkout with your
            personalised design pre-loaded. Once payment is complete, Zazzle prints the
            item to order and ships it to the address you provide. Map Shaper never
            handles the product physically.
        </p>

        <h2>Production time</h2>
        <p>
            Print-on-demand items are usually produced in 1–3 business days. Some
            products (cups, t-shirts, basic prints) ship same-day or next-day; others
            (hoodies, framed prints, hard cases) take longer.
        </p>

        <h2>Delivery time</h2>
        <p>
            Delivery depends on your country and the shipping option you choose at
            checkout. Zazzle ships internationally; estimated delivery dates appear on
            the checkout page before you pay.
        </p>

        <h2>Returns and refunds</h2>
        <p>
            Returns and refunds are handled by Zazzle under their standard policy.
            They offer a 30-day satisfaction guarantee on most custom-printed products.
            If something arrives wrong or damaged, contact Zazzle directly through the
            order confirmation email you received from them.
        </p>

        <h2>Order tracking</h2>
        <p>
            Zazzle sends a tracking number by email once your order ships. We don't have
            access to your order or shipping details — please reach out to Zazzle for
            anything order-specific.
        </p>

        <h2>Questions</h2>
        <p>
            Questions about products or design before you order:{' '}
            <a href="mailto:mapshaped@gmail.com">mapshaped@gmail.com</a>. Questions
            about an existing order: contact Zazzle.
        </p>
    </StaticPage>
);

export default ShippingPage;
